module.exports = {
      id: "comm-finance-usage",
      viewBox: "0 0 245.601 29.882",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-finance",
      toString: function () {
        return this.url;
      }
    }